// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--kTZLS","bigger":"styles-module--bigger--oXlTK","biggest":"styles-module--biggest--2LNab","smallTitle":"styles-module--small-title--1TFuU"};